import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import ResetPassword from "../common/components/ResetPassword";
import { usePublicNavBar } from "./NavBar";

export const AngularResetPassword = ({ username, resetToken }) => <ResetPassword username={username} resetToken={resetToken}></ResetPassword>

export const ReactResetPassword = () => {
    const { t } = useTranslation();
    const { setTitle } = usePublicNavBar();
    const [searchParams] = useSearchParams();
    const username = searchParams.get('username');
    const resetToken = searchParams.get('reset_token');

    useEffect(() => setTitle(t('resetPassword')), [t, setTitle]);

    return <>
            { username && resetToken && <ResetPassword username={username} resetToken={resetToken}></ResetPassword> }
            { (!username || !resetToken) && <div>{t('')}</div> }
        </>
}